/* eslint-disable @repo/internal/react/require-jsdoc */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { type ReactNode } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';

import { token } from '@atlaskit/tokens';

interface TooltipButtonRenderProps {
	isHovered?: boolean;
	children?: ReactNode;
}

interface BaseTokenButtonStyleProps extends TooltipButtonRenderProps {
	className?: string;
}

const baseTokenButtonUiStyles = css({
	display: 'flex',
	boxSizing: 'border-box',
	width: '100%',
	minHeight: '1.5rem',
	padding: `${token('space.025')} ${token('space.150')}`,
	alignItems: 'center',
	justifyContent: 'center',
	background: 'none',
	//eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
	borderRadius: token('radius.small', '3px'),
	color: token('color.text'),
	font: token('font.body.small'),
	fontFamily: token('font.family.code'),
	'&:hover, &:focus': {
		background: token('color.background.neutral.hovered'),
	},
	'&:active': {
		background: token('color.background.neutral.pressed'),
	},
});

export const BaseTokenButtonStyle = ({
	children,
	isHovered,
	className,
}: BaseTokenButtonStyleProps): ReactNode => {
	return (
		<span
			css={baseTokenButtonUiStyles}
			data-is-hovered={isHovered}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className={className}
		>
			{children}
		</span>
	);
};
